import { ConfigService } from '@services/webFeeder/config.service';
import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Subject, Subscription , of } from 'rxjs';
import { NgxMasonryOptions } from 'ngx-masonry';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AuthServer } from '@services/auth-server.service';
import { NotificationsService } from 'angular2-notifications';
import { Constants } from '@utils/constants';
import { AutoLogoutService } from '@auth/auto-logout-service.service';
import { StatusOmsService } from '@services/webFeeder/sckt-status-oms.service';
import { StatusConnection } from '@model/status-connection';
import { BrokerageNoteTypeEnum } from '@model/enum/brokerage-note-type.enum';
import * as moment from 'moment';

@Component({
  selector: 'app-brokerage-note',
  templateUrl: './brokerage-note.component.html'
})
export class BrokerageNoteComponent implements OnInit, OnDestroy {

  title = Constants.TITLE_CARD_MODAL_BROKERAGE;
  radioButtonList = [
    { id: 0, desc: 'Última Nota' },
    { id: 1, desc: 'Data Específica' },
    { id: 2, desc: 'Minhas Notas' }
  ];
  brokerageNoteTypeEnum = BrokerageNoteTypeEnum;
  selectRadio = 0;
  loading = false;
  dateStartFilter: Date;
  dateEndFilter: Date;
  changingValue: Subject<boolean> = new Subject();
  myOptions: NgxMasonryOptions = {
    originLeft: true,
  };
  // transitionDuration: '1.17s',
  urlPdf2: any;
  urlPdf: SafeResourceUrl;
  account: string;
  market: string;
  dataFilter: any;
  showNote = false;
  condition = false;
  dateList = [];
  pdfStream: Blob;
  pdfName: string;
  listMarket = [
    { value: 'XBSP', desc: 'Bovespa' },
    { value: 'XBMF', desc: 'BMF' }
  ];
  private subscriptionStatusOms: Subscription;
  statusOmsOnline: boolean;
  msgStatusOmsOffile = Constants.MSG_STATUS_OFFLINE_OMS;
  isLoginW = this._configService.isLoginTypeWSO2();
  wasBrokerageFetched = false;

  @HostListener('mousemove')
  onMouseMove() {
    this._autoLogoutService.resetTime();
  }

  @HostListener('click')
  onClick() {
    this._autoLogoutService.resetTime();
  }

  constructor(
    public dialogRef: MatDialogRef<BrokerageNoteComponent>,
    private sanitizer: DomSanitizer,
    private _configService: ConfigService,
    private _authServer: AuthServer,
    private _notificationService: NotificationsService,
    private _autoLogoutService: AutoLogoutService,
    private _statusOmsService: StatusOmsService
  ) {
    this.account = this._configService.getBrokerAccountSelected();
    this.dataFilter = new Date();
    this.market = this.listMarket[0].value;
    this.pdfStream = null;
    this.pdfName = 'NotaCorretagem_';
    this.subscriptionStatusOms = this._statusOmsService.messagesStatusOms
      .subscribe(statusOms => {
        if (statusOms === StatusConnection.ERROR) {
          this.loading = false;
          this.statusOmsOnline = false;
        } else {
          this.statusOmsOnline = true;
        }
      });
  }

  ngOnInit() {

  }

  ngOnDestroy() {
    this.changingValue.unsubscribe();
    if (this.subscriptionStatusOms) {
      this.subscriptionStatusOms.unsubscribe();
    }
  }

  close() {
    this.dialogRef.close();
  }

  changeTypeRadio(item) {
    this.resetDateFilter();
    this.clearFilter();
    this.selectRadio = item.id;
    this.clearNote();
    this.wasBrokerageFetched = false;
  }

  changeDateIni(value) {
    if (value) {
      this.dateStartFilter = new Date(value);
      setTimeout(() => {
        this.dataFilter = new Date(value);
      });
    }
  }

  changeDateFim(value) {
    if (value) {
      this.dateEndFilter = new Date(value);
    }
  }

  clearFilter() {
    this.changingValue.next(true);
    this.dateStartFilter = null;
    this.dateEndFilter = null;
  }

  viewNote(value) {
    this.dataFilter = moment(value, 'DD/MM/YYYY');
    this.searchFilter();
  }

  searchFilter() {
    if (!this.account || !this.market || !this.dataFilter) {
      this._notificationService.error('', 'Paramêtros incorretos.');
      return;
    }
    this.loading = true;
    this.wasBrokerageFetched = true;
    this.urlPdf = null;
    this.showNote = false;
    this._authServer.iNegotiation.brokeragePDF(this.account, this.market, this.dataFilter)
      .subscribe(res => {
        this.clearNote();
        if (res && res.size > 60) {
          this.pdfStream = res;
          this.condition = true;
          this.showNote = true;
          var newBlob = new Blob([res], { type: "application/pdf" });
          this.urlPdf = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(newBlob));
        } else {
          if (!this.isLoginW && !this.urlPdf) {
            this.urlPdf = null;
          }
          this._notificationService.error('', Constants.BROKERAGE_MSG_001);
        }
        this.loading = false;
      }, error => {
        this._notificationService.error('', Constants.BROKER_MSG002);
        this.urlPdf = null;
        this.loading = false;
      });
  }

  fetchNote(itemSelect) {
    switch (itemSelect) {
      case this.brokerageNoteTypeEnum.LAST_NOTE:
        this.getBrokerageEndDate();
        break;
      case this.brokerageNoteTypeEnum.SPECIFIC_DATE:
        this.searchFilter();
        break;
      case this.brokerageNoteTypeEnum.MY_NOTE:
        this.brokerageDates();
        break;
      default:
        break;
    }
  }

  clearNote() {
    this.showNote = false;
    this.condition = false;
    this.urlPdf = null;
    this.dateList = [];
  }

  resetDateFilter() {
    this.dataFilter = null;
  }

  brokerageDates() {
    const startDate = this.dateStartFilter ? moment(this.dateStartFilter).format('DDMMYYYY') : null;
    const endDate = this.dateEndFilter ? moment(this.dateEndFilter).format('DDMMYYYY') : null;
    this.getBrokerageDates(startDate, endDate);
  }

  getBrokerageEndDate() {
    const startDate = '';
    const endDate = '';
    this.getBrokerageDates(startDate, endDate);
  }

  getBrokerageDates(startDate, endDate) {
    this.loading = true;
    this.wasBrokerageFetched = true;
    this._authServer.iNegotiation.brokerageDates(this.account, this.market, startDate, endDate)
      .subscribe(result => {
        this.clearNote();
        this.dateList = [];
        if (result && result.dates && result.dates.length > 0) {
          if (this.selectRadio === BrokerageNoteTypeEnum.LAST_NOTE) {
            this.dataFilter = moment(result.dates[result.dates.length - 1]);
            this.searchFilter();
          } else {
            result.dates.forEach(element => {
              this.dateList.push(moment(element).format('DD/MM/YYYY'));
            });
            this.dateList.reverse();
          }
        } else {
          this._notificationService.error('', Constants.BROKERAGE_MSG_001);
        }
        this.loading = false;
      });
  }

  convertBase64(blob, market, isBase64?, nameProduct?) {
    let base64: any;
    if (!isBase64) {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = function () {
        base64 = reader.result;
      };
    } else {
      base64 = blob.data;
    }
    setTimeout(() => {
      this.urlPdf2 = base64;
    }, 100);
  }

  downloadPdf() {
    var dataPdf = this.formatDateToPrint(this.dataFilter);
    var mercadoPdf = this.formatMarketToPrint(this.market);

    if (this.pdfStream) {
      var newBlob = this.pdfStream;
      let navigator: any = window.navigator
      if (navigator && navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(newBlob);
        return;
      }

      const data = window.URL.createObjectURL(newBlob);
      var link = document.createElement('a');
      link.href = data;
      link.download = this.pdfName + dataPdf + '_' + mercadoPdf + '.pdf';
      link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
        link.remove();
      }, 100);
    }
  }

  formatDateToPrint(dateValue) {
    return moment(dateValue).format('DDMMYYYY');
  }

  formatMarketToPrint(market) {
    for (var i = 0; i <= this.listMarket.length; i++) {
      if (this.listMarket[i].value == market) {
        return this.listMarket[i].desc;
      }
    }
  }

}
